import type { TableProps } from 'antd5';
import { Link } from 'react-router-dom';

import { None, strong } from 'components/data/helpers';

import { type TTurbineProps } from '../../types';

import { SeverityContainer, StyledCircle } from './TurbinesList.Styles';

const severityRender = (severity?: number) => {
  return (
    <SeverityContainer>
      {severity ? (
        <>
          <StyledCircle severity={severity} />
          <span>{severity}</span>
        </>
      ) : (
        <None />
      )}
    </SeverityContainer>
  );
};

const inspectionDateRender = (value?: TTurbineProps['inspectionData']) => {
  const { id, inspectionDate } = value ?? {};
  if (!id || !inspectionDate) {
    return <None />;
  }

  return (
    <Link to={`/inspections/${id}`} target="_blank" rel="noopener noreferrer">
      {inspectionDate}
    </Link>
  );
};

export const getTurbineColums = (): TableProps<TTurbineProps>['columns'] => [
  {
    title: strong('Turbine'),
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
    render: (value?: string) => value ?? <None />,
    width: '35%',
  },
  {
    title: strong('Most Recent Inspection'),
    dataIndex: 'inspectionData',
    key: 'inspectionData',
    render: inspectionDateRender,
    width: '35%',
  },
  {
    title: strong('Max Severity'),
    dataIndex: ['inspectionData', 'maxSeverity'],
    key: 'severity',
    render: severityRender,
    width: '30%',
  },
];
